import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TimesheetService } from '../components/timesheet-final/services/timesheet.service';
import { applyMyTimesheetDeepLinkFromUrl } from '../components/timesheet-final/utils/apply-my-timesheet-deep-link';
import { SnackbarService } from '../services/snack-service/snackbar-service';

/**
 * Applies My Timesheet email deep-link query params before the lazy child route loads.
 * `state.url` is the authoritative target URL during navigation (incl. email / returnUrl).
 */
export const myTimesheetDeepLinkGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const timesheetService = inject(TimesheetService);
  const snackbar = inject(SnackbarService);
  applyMyTimesheetDeepLinkFromUrl(router, timesheetService, state.url, snackbar);
  return true;
};
